import { Col, Form, Row, Button } from "@themesberg/react-bootstrap";
import { useContext, useEffect, useState } from "react";
import Select from "react-select";
import {
	HOME_SECTIONS_REDUCER_CREATE,
	HOME_SECTIONS_REDUCER_UPDATE,
} from "src/app/common/constants";
import ToastPopup from "src/app/common/ToastPopup";
import { PropertyContext } from "src/app/contexts/PropertyContext";

const customStyles = {
	control: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValue: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValueRemove: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	placeholder: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";

		return {
			...provided,
			opacity,
			transition,
		};
	},
};

const HomeSectionsForm = ({
	categoryData,
	propertyDataLite,
	singleHomeSection,
	getAllHomeSectionsFromContext,
	createNewHomeSectionFromContext,
	updateHomeSectionFromContext,
	deleteHomeSectionFromContext,
	newSectionForm,
	setNewSectionForm,
}) => {
	const [homeSectionData, setHomeSectionData] = useState({
		section: "",
		content_strategy: "",
		priority: 0,
		static_ids: [],
		cat_ids: [],
	});

	//console.log(homeSectionData);

	const handleOnDelete = () => {
		if (singleHomeSection) {
			deleteHomeSectionFromContext(singleHomeSection?.id, () =>
				getAllHomeSectionsFromContext()
			);
		}
	};

	const handleOnSubmit = () => {
		if (
			homeSectionData?.section !== "" &&
			((homeSectionData?.content_strategy === "latest" &&
				homeSectionData?.cat_ids?.length > 0) ||
				(homeSectionData?.content_strategy === "static" &&
					homeSectionData?.static_ids?.length >= 6 &&
					homeSectionData?.static_ids?.length <= 30)) &&
			homeSectionData?.priority >= 0
		) {
			let data = homeSectionData;

			if (homeSectionData?.["content_strategy"] === "latest") {
				data = {
					...data,
					static_ids: null,
				};
			} else {
				data = {
					...data,
					cat_ids: null,
				};
			}

			if (singleHomeSection) {
				updateHomeSectionFromContext(data?.id, data, () => getAllHomeSectionsFromContext());
			} else {
				createNewHomeSectionFromContext(data, () => getAllHomeSectionsFromContext());

				if (newSectionForm !== null && setNewSectionForm !== null) {
					setNewSectionForm(!newSectionForm);
				}
			}
		} else {
			console.log("not passed~~");

			if (homeSectionData?.section === "") {
				ToastPopup("error", "Section name should be provided!!");
				return;
			}

			if (
				homeSectionData?.content_strategy === "latest" &&
				homeSectionData?.cat_ids?.length <= 0
			) {
				ToastPopup("error", "At least 1 section data by category should be provided!!");
				return;
			}

			if (
				homeSectionData?.content_strategy === "static" &&
				(homeSectionData?.static_ids?.length < 6 ||
					homeSectionData?.static_ids?.length > 30)
			) {
				ToastPopup(
					"error",
					"Section data by property should be more than 6 and less than 30!!"
				);
				return;
			}
		}
	};

	const handleSectionDataInputChange = (key, datas) => {
		//console.log(datas);
		setHomeSectionData({
			...homeSectionData,
			[key]: datas?.map((data) => data?.value?.id),
		});
	};

	const handleInputChange = (e) => {
		if (!e?.target) return;

		setHomeSectionData({
			...homeSectionData,
			[e.target.dataset.key]: e.target.value,
		});
	};

	useEffect(() => {
		if (singleHomeSection) {
			setHomeSectionData(singleHomeSection);
		}
	}, [singleHomeSection]);

	return (
		<>
			<Row>
				<Col md={12} className="mb-3">
					<Form.Group id="sectionName">
						<Form.Label>Section Name</Form.Label>
						<Form.Control
							required
							type="text"
							name="section_name"
							data-key="section"
							value={homeSectionData?.["section"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Section name"
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col sm={6} className="mb-3">
					<Form.Group id="sectionDataType">
						<Form.Label>Section Data Type</Form.Label>
						<Form.Select
							required
							id="section_data_type"
							name="section_data_type"
							defaultValue="0"
							data-key="content_strategy"
							value={homeSectionData?.["content_strategy"] ?? "0"}
							onChange={(e) => handleInputChange(e)}
						>
							<option value="0">Select Section Data Type</option>
							<option value="latest">By Category</option>
							<option value="static">By Property</option>
						</Form.Select>
					</Form.Group>
				</Col>
				<Col sm={6} className="mb-3">
					<Form.Group id="sectionPriority">
						<Form.Label>Section Priority</Form.Label>
						<Form.Control
							required
							type="number"
							name="section_priority"
							data-key="priority"
							value={homeSectionData?.["priority"] ?? 0}
							onChange={(e) => handleInputChange(e)}
							placeholder="Section priority"
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row>
				<Col md={12} className="mb-3">
					<Form.Group id="sectionDataIds">
						<Form.Label>Section Data</Form.Label>

						<Select
							options={
								homeSectionData?.["content_strategy"] === "latest"
									? categoryData?.map((category) => ({
											label: category.name,
											value: category,
									  }))
									: homeSectionData?.["content_strategy"] === "static"
									? propertyDataLite?.map((property) => ({
											label: property.name,
											value: property,
									  }))
									: []
							}
							value={
								homeSectionData?.["content_strategy"] === "latest"
									? categoryData
											?.filter(
												(category) =>
													homeSectionData?.["cat_ids"]?.indexOf(
														category.id
													) >= 0
											)
											?.map((category) => ({
												label: category.name,
												value: category,
											}))
									: homeSectionData?.["content_strategy"] === "static"
									? propertyDataLite
											?.filter(
												(property) =>
													homeSectionData?.["static_ids"]?.indexOf(
														property.id
													) >= 0
											)
											?.map((property) => ({
												label: property.name,
												value: property,
											}))
									: []
							}
							theme={(theme) => ({
								...theme,
								borderRadius: 0,
								colors: {
									...theme.colors,
									primary25: theme.colors.neutral10,
									primary: theme.colors.neutral30,
								},
							})}
							styles={customStyles}
							isMulti
							onChange={(e) =>
								handleSectionDataInputChange(
									homeSectionData?.["content_strategy"] === "latest"
										? "cat_ids"
										: homeSectionData?.["content_strategy"] === "static"
										? "static_ids"
										: "",
									e
								)
							}
						/>
					</Form.Group>
				</Col>
			</Row>

			<Row>
				<Col lg={12}>
					<div className="text-end">
						{singleHomeSection && (
							<Button
								variant="danger"
								className="m-1"
								onClick={() => handleOnDelete()}
							>
								Delete
							</Button>
						)}
						<Button variant="gray" className="m-1" onClick={() => handleOnSubmit()}>
							{singleHomeSection ? "Update" : "Create"}
						</Button>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default HomeSectionsForm;
